import { ComponentProps } from 'react';

import { ProgressCircular } from '@mint-lib/tw-components/patterns';

type LoaderProps = ComponentProps<typeof ProgressCircular>;

export function Loader(props: LoaderProps) {
  return (
    <div className="flex h-full w-full flex-1 items-center justify-center">
      <ProgressCircular {...props} />
    </div>
  );
}
